import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ssoTokenValidation } from '../../api/authentication.api';
import { authenticationService } from '../../services/authentication.service';
import LoaderFull from '../Loader/Loader'
import { toast } from 'react-toastify';

function SsoValidation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const queryParams = new URLSearchParams(location.search);
  const ssoToken = queryParams.get('ssotoken');

  const validateSso = async (token) => {
    try {
      const { data }= await ssoTokenValidation({ssotoken: token});
      authenticationService.loginData(data);
      navigate('/dashboard')
    } catch (error) {
      toast.error('Access Denied')
      navigate('/');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!ssoToken) {
      navigate('/');
    } else {
      validateSso(ssoToken);
    }
  }, [ssoToken]);

  return (
    <>
      {loading ? (
        <LoaderFull />
      ) : (
        <div>SSO token validated</div>
      )}
    </>
  );
}

export default SsoValidation;
